import { useRouter } from 'next/router';
import RequiresAuth from '@website/components/auth/RequiresAuth';
import UserBookingDetails from '@website/components/me/bookings/UserBookingDetails';
import LoadingPage from '../../../../../components/utilities/LoadingPage';

export default function BookingPage() {
  const { query } = useRouter();

  if (!query.bookingId) return <LoadingPage />;

  return (
    <RequiresAuth>
      <UserBookingDetails query={query} />
    </RequiresAuth>
  );
}
